//import required libraries
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/popover'
import './site.scss'
const $ = require('jquery');

$(() => {

    let disableNavBarOnScroll = false;

    $('.nav-link').on('click', () => {
        if (window.scrollY > 50) {
            $('#navbar').hide();
        }
        disableNavBarOnScroll = true;
        let prevScroll = window.scrollY;
        let enableScrollNavBarTimer = setInterval(() => {
            if (window.scrollY === prevScroll) {
                disableNavBarOnScroll = false;
                clearInterval(enableScrollNavBarTimer);
            }
            prevScroll = window.scrollY;
        }, 100);
    });
    //hide navbar when scrolling down, show when scrolling up
    let originScroll = 0;
    $(window).on('scroll', () => {
        if (window.scrollY <= 50 || (!disableNavBarOnScroll && window.scrollY - originScroll < 0)) {
            $('#navbar').show();
        } else {
            $('#navbar').hide();
        }
        originScroll = window.scrollY;
    });

    let enableResizeNavBarTimeout;
    $(window).on('resize', () => {
        disableNavBarOnScroll = true;
        if (enableResizeNavBarTimeout) {
            clearTimeout(enableResizeNavBarTimeout);
        }
        enableResizeNavBarTimeout = setTimeout(() => {
            disableNavBarOnScroll = false;
            enableResizeNavBarTimeout = null;
        }, 100);
    });
})